import React from "react";
import LegalPage from "../../components/LegalPage";

// Data Processing Agreement - PDF provided by Zelaflo Labs.
const PDF = "https://customer-assets.emergentagent.com/job_workflow-builder-125/artifacts/xhvc0fgh_Zelaflo_Labs_Data_Processing_Agreement.pdf";

export default function DataProcessingAgreement() {
  return (
    <LegalPage
      title="Data Processing Agreement"
      pdfUrl={PDF}
      description="Our GDPR-compliant data processing terms for business clients."
      testId="legal-dpa"
    />
  );
}
